import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ControlsOf } from '@ngneat/reactive-forms';
import { TranslocoService } from '@ngneat/transloco';
import {
  DynamicFormControlService,
  FormForm,
  VinnovaFormRendererModule,
} from '@vinnova/formrenderer';
import { catchError, map, Observable, throwError } from 'rxjs';
import { FormQuery } from '../../core/queries/form.query';

@Component({
  selector: 'app-formular-preview',
  imports: [CommonModule, VinnovaFormRendererModule],
  templateUrl: './formular-preview.component.html',
  styleUrl: './formular-preview.component.scss',
  providers: [DynamicFormControlService],
})
export class FormularPreviewComponent implements OnInit {
  constructor(
    private routes: ActivatedRoute,
    private dynamicFormControlService: DynamicFormControlService,
    private translocoService: TranslocoService,
    private formQuery: FormQuery,
    private router: Router,
  ) {}

  parsedForm$: Observable<FormGroup<ControlsOf<FormForm>>>;

  isTestable: boolean;
  activeLang: string;
  formTitle: string;

  ngOnInit(): void {
    const formId = this.routes.snapshot.paramMap.get('formId');
    this.parsedForm$ = this.formQuery.getLatestPublication(formId).pipe(
      catchError((err) => {
        if (err.status === 404) {
          this.router.navigateByUrl('/not-found', {
            skipLocationChange: true,
          });
        } else {
          this.router.navigateByUrl('/error', { skipLocationChange: true });
        }
        return throwError(() => err);
      }),
      map((publication) => {
        this.formTitle = publication.form.title;
        return this.dynamicFormControlService.formToFormGroup(publication.form);
      }),
    );
    this.isTestable = this.routes.snapshot.data.testable;
    this.activeLang = this.translocoService.getActiveLang();
  }
}
